var React = require('react');

function CheckBoxDefault (props) {
    return React.createElement("svg",props,React.createElement("rect",{"width":"15","height":"15","x":".5","y":".5","fill":"#FFF","fillRule":"evenodd","stroke":"#E5E7E8","rx":"2"}));
}

CheckBoxDefault.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = CheckBoxDefault;

CheckBoxDefault.default = CheckBoxDefault;
